import { deleteCreditTariffRequest } from 'api/Credit/api';
import getErrorFromPromiseReason from 'app/helpers/getErrorFromPromiseReason';

import { message, notification } from 'antd';
import { useState } from 'react';

const useDeleteCreditTariff = (onCreditTariffDeleted: (creditTariffId: string) => void) => {
  const [ deletingId, setDeletingId ] = useState<string | null>(null);

  const deleteCreditTariff = (creditTariffId: string) => {
    setDeletingId(creditTariffId);

    deleteCreditTariffRequest(creditTariffId)
      .then(() => {
        message.success('Tariff was removed');
        onCreditTariffDeleted(creditTariffId);
      })
      .catch((reason) => {
        notification.error({ duration: 0, type: 'error', message: getErrorFromPromiseReason(reason) });
      })
      .finally(() => {
        setDeletingId(null);
      });
  };

  return { deletingId, deleteCreditTariff };
};

export default useDeleteCreditTariff;
